import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {withTranslation} from "react-i18next";
import {RootState} from "../../../reducers";
import StringHelper from "../../services/Common/StringHelper";
import {ConfigApi, MultistoreItemTitleType} from "../../services/Api/types";
import {ReactComponent as ArrowBottomSVG} from "../../../images/icons/arrow-bottom.svg";
import {Link} from "react-router-dom";

interface OwnProps {
    config: ConfigApi
    multistoreConfig?: ConfigApi;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function NavbarPlaces(props: Props) {
    const addressName = StringHelper.getAddressName(props.config.address);
    const multiStoreItemTitleType = props.multistoreConfig?.layout.multistore_item_title_type ?? MultistoreItemTitleType.BOTH;
    const title = multiStoreItemTitleType === MultistoreItemTitleType.BOTH ? props.config.name : addressName || props.config.name;
    const description = multiStoreItemTitleType === MultistoreItemTitleType.BOTH ? addressName : undefined;

    return (
        <>
            <Link to={"/map"} className={"btn btn-choose-place btn-flex btn-choose-place-with-logo"}>
                <div className={"multiline"}>
                    <h5>
                        {title}
                    </h5>
                    {description && (
                        <small>
                            {description}
                        </small>
                    )}
                </div>
                <ArrowBottomSVG/>
            </Link>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(NavbarPlaces));